import { createContext, useState, useEffect } from "react";

const UIContext = createContext({
  sideBarSize: null,
  setSideBarSize: () => {},
  windowSize: {},
});

export const UIProvider = ({ children }) => {
  const [sideBarSize, setSideBarSize] = useState();
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <UIContext.Provider
      value={{
        sideBarSize,
        setSideBarSize,
        windowSize,
      }}
    >
      {children}
    </UIContext.Provider>
  );
};

export default UIContext;
